import { Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = ({ settings }) => (
  <footer className="bg-slate-900 text-slate-300" data-testid="main-footer">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="inline-block bg-white rounded-md px-4 py-2">
            <img src="/assets/prgl-logo.png" alt="PRGL" className="h-8 w-auto" />
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-xs leading-relaxed">
            {settings.tagline} — van & crew delivery specialists based in {settings.address}.
          </p>
        </div>
        <div className="text-sm space-y-3">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-slate-500 mb-4">Quick links</p>
          <a href="#jobs" className="block hover:text-white transition-colors">Join Our Crew</a>
          <a href="#services" className="block hover:text-white transition-colors">Services</a>
          <a href="#hire-us" className="block hover:text-white transition-colors">Book Us</a>
          <a href="#contact" className="block hover:text-white transition-colors">Contact</a>
        </div>
        <div className="text-sm space-y-3">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-slate-500 mb-4">Get in touch</p>
          <p>{settings.phone}</p>
          <p>{settings.email}</p>
          <p>{settings.domain}</p>
          <div className="flex gap-4 pt-2">
            <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" aria-label="Facebook"
              data-testid="footer-facebook-link" className="hover:text-white transition-colors"><Facebook size={20} /></a>
            <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
              data-testid="footer-instagram-link" className="hover:text-white transition-colors"><Instagram size={20} /></a>
          </div>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
        <p>Copyright © {new Date().getFullYear()} {settings.company_name} — All Rights Reserved.</p>
        <Link to="/prgladmin.backend" data-testid="footer-admin-link" className="hover:text-slate-300 transition-colors">Admin</Link>
      </div>
    </div>
  </footer>
);
